<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'CURRENCY.ADD' | translate}}</h2>

    <div class="col-xs-12">

        <div [hidden]="submitted">
            <form (ngSubmit)="onSubmit()" #currencyForm="ngForm">
                <button type="submit" class="btn btn-primary" style="float: right;" [disabled]="!currencyForm.form.valid">{{'FUNCTION-BUTTONS.SAVE' | translate}}
        </button>
                <button class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="goToList()">{{'FUNCTION-BUTTONS.CANCEL' | translate}}</button>

                <br/>
                <br/><br/>
                <div class="form-group">
                    <label for="name">{{'CURRENCY.NAME' | translate}}</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="currency.name" name="name" #name="ngModel" required>
                    <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
                        {{'CURRENCY.NAME_REQUIRED' | translate}}
                    </div>
                </div>

                <div class="form-group">
                    <label for="code">{{'CURRENCY.CODE' | translate}}</label>
                    <input type="text" class="form-control" id="code" [(ngModel)]="currency.code" name="code" #code="ngModel" required>
                    <div [hidden]="code.valid || code.pristine" class="alert alert-danger">
                        {{'CURRENCY.CODE_REQUIRED' | translate}}
                    </div>
                </div>

            </form>
        </div>
    </div>
</div>